import React from "react";
import PropTypes from "prop-types";

import {
  ReactDefaultProps,
  ReactComponentStaticProps,
} from "../../types/react";

import styles from "./A11yText.scss";

export const A11yTextDefaultTag = "span";
export type A11yTextDefaultTagType = typeof A11yTextDefaultTag;

type A11yTextBaseProps<
  Tag extends React.ElementType = A11yTextDefaultTagType
> = {
  tag?: Tag;
};

export type A11yTextProps<
  Tag extends React.ElementType = A11yTextDefaultTagType
> = A11yTextBaseProps<Tag> &
  Omit<React.ComponentPropsWithoutRef<Tag>, keyof A11yTextBaseProps<Tag>>;

const defaultProps = {
  tag: A11yTextDefaultTag,
} as const;

const validatedDefaultProps: ReactDefaultProps<
  A11yTextBaseProps,
  typeof defaultProps
> = defaultProps;

export const A11yText: (<
  Tag extends React.ElementType = A11yTextDefaultTagType
>(
  props: A11yTextProps<Tag>
) => JSX.Element) &
  ReactComponentStaticProps<A11yTextProps, "tag"> = ({
  tag,
  children,
  ...props
}) => {
  if (!tag) {
    return <></>;
  }
  const CustomTag = tag as React.ElementType;
  return (
    <CustomTag className={styles.a11y} {...props}>
      {children}
    </CustomTag>
  );
};

A11yText.propTypes = {
  tag: PropTypes.elementType,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
} as const;

A11yText.defaultProps = validatedDefaultProps;

A11yText.displayName = "A11yText";

export default A11yText;
